const twoFactorAuthIT = {
    "view": {
        "title": "Autenticazione a Due Fattori",
        "form": {
            "label": {
                "currentMethod": "Metodo Attuale di Autenticazione a Due Fattori",
                "authenticatorSetupTitle": "Configura la tua App Authenticator",
                "scanInstructions": "Scansiona il codice QR qui sotto utilizzando qualsiasi app Authenticator TOTP (come Authy, Google Authenticator, Microsoft Authenticator ecc.).",
                "qrCodeAlt": "Codice QR per la configurazione dell'autenticatore",
                "step1": "Apri la tua app authenticator.",
                "step2": "Seleziona l'opzione per aggiungere un nuovo account.",
                "step3": "Scegli l'opzione \"Scansiona un codice QR\" nell'app.",
                "step4": "Punta la fotocamera del tuo telefono sul codice QR sopra.",
                "step5": "Una volta scansionato, l'autenticatore inizierà a generare un codice OTP a 6 cifre che si aggiorna ogni 30 secondi. Questo codice OTP può essere utilizzato per completare il processo di accesso.",
                "appLinks": "Ecco i link per alcune app authenticator comuni:",
                "appLinksAuthy": "Authy",
                "appLinksGoogle": "Google Authenticator",
                "appLinksMicrosoft": "Microsoft Authenticator",
                "googlePlay": "Google Play Store",
                "appStore": "Apple App Store",
                "loadingQrCode": "Caricamento del codice QR...",
                "emailSetupTitle": "Autenticazione a Due Fattori tramite Email",
                "emailDescription": "Riceverai una Password Monouso (OTP) al tuo indirizzo email registrato, che può essere utilizzata per completare il processo di accesso. Assicurati di controllare la tua casella di posta o la cartella spam per l'OTP quando accedi."
            },
            "help_text": {
                "currentMethod": "L'email è attualmente impostata come metodo predefinito per l'Autenticazione a Due Fattori. Tuttavia, consigliamo di utilizzare il metodo Authenticator per una maggiore sicurezza."
            },
            "option": {
                "2faMethod": {
                    "selectMethod": "Seleziona Metodo 2FA",
                    "email": "Email",
                    "auth": "Authenticator"
                }
            },
            "button": {
                "save": "Salva",
                "saving": "Salvataggio in corso..."
            }
        },
        "backupCodes": {
            "title": "Codici di Backup",
            "view": {
                "button": {
                    "generate": "Genera Codici di Backup",
                    "download": "Scarica Codici di Backup"
                },
                "modal": {
                    "header": "I tuoi Codici di Backup",
                    "body": {
                        "noCodes": "Nessun codice di backup disponibile"
                    }
                }
            }
        }
    }
};

export default twoFactorAuthIT;